// Einwilligungen: Kategorien und eingesetzte Dienste. Ohne Server-Abhängigkeiten.
// Eine Kategorie erscheint im Banner nur, wenn mindestens ein Dienst sie nutzt.

export const CATEGORIES = {
  necessary: {
    label: "Notwendig",
    text: "Speichert deine Auswahl in diesem Browser und hält Admins angemeldet. Ohne das funktioniert die Seite nicht; daher immer aktiv.",
  },
  statistics: {
    label: "Statistik",
    text: "Hilft uns zu verstehen, welche Seiten gelesen werden. Ausgewertet auf unserem eigenen Server, ohne Weitergabe an Dritte.",
  },
  media: {
    label: "Externe Medien",
    text: "Lädt Inhalte anderer Anbieter, zum Beispiel Videos. Dabei werden Daten wie deine IP-Adresse an diese Anbieter übertragen.",
  },
  marketing: {
    label: "Marketing",
    text: "Erlaubt Funktionen von Werbe- und Social-Media-Partnern, die dein Verhalten seitenübergreifend auswerten können.",
  },
} as const;
export type Category = keyof typeof CATEGORIES;
export type OptionalCategory = Exclude<Category, "necessary">;

export type Service = {
  id: string;
  name: string;
  category: OptionalCategory;
  provider: string;
  purpose: string;
  privacyUrl: string;
  /** Drittland-Übermittlung, für den Hinweis im Dialog */
  thirdCountry?: string;
  /** Für die Content-Security-Policy */
  frameOrigins?: string[];
};

export const SERVICES: Service[] = [
  {
    id: "youtube",
    name: "YouTube",
    category: "media",
    provider: "Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland",
    purpose: "Eingebettete Videos abspielen (erweiterter Datenschutzmodus youtube-nocookie.com).",
    privacyUrl: "https://policies.google.com/privacy",
    thirdCountry: "USA",
    frameOrigins: ["https://www.youtube-nocookie.com"],
  },
  {
    id: "vimeo",
    name: "Vimeo",
    category: "media",
    provider: "Vimeo.com Inc., 330 West 34th Street, New York, NY 10001, USA",
    purpose: "Eingebettete Videos abspielen (mit „Do Not Track“).",
    privacyUrl: "https://vimeo.com/privacy",
    thirdCountry: "USA",
    frameOrigins: ["https://player.vimeo.com"],
  },
];

export const ACTIVE_CATEGORIES = (Object.keys(CATEGORIES) as Category[]).filter(
  (c): c is OptionalCategory => c !== "necessary" && SERVICES.some((s) => s.category === c),
);
export const servicesIn = (c: Category) => SERVICES.filter((s) => s.category === c);
export const FRAME_ORIGINS = [...new Set(SERVICES.flatMap((s) => s.frameOrigins ?? []))];

/** Ändert sich die Liste der Dienste, fragen wir erneut. */
export const CONSENT_VERSION = SERVICES.map((s) => `${s.id}:${s.category}`).sort().join(",");
/** Nach einem Jahr fragen wir erneut. */
export const CONSENT_MAX_AGE_MS = 365 * 86_400_000;

export type Consent = { v: string; at: string } & Record<OptionalCategory, boolean>;

export const PRIVACY_PATH = "/datenschutz";
export const IMPRINT_PATH = "/impressum";
